(function ($) {
    $.fn.dateagpm = function () {
        function pad(s) {
            return (s < 10) ? '0' + s : s;
        }

        function isFr(string) {
            let pattern = /^(\d{2})\/(\d{2})\/(\d{4})$/;
            return string.match(pattern)
        }

        function frToIt(string) {
            let pattern = /^(\d{2})\/(\d{2})\/(\d{4})$/;

            if (string.match(pattern)) {
                return string.replace(pattern, '$3-$2-$1');
            }
            return string;
        }

        function itToFr(string) {
            let pattern = /^(\d{4})-(\d{2})-(\d{2})$/;

            if (string.match(pattern)) {
                return string.replace(pattern, '$3\/$2\/$1');
            }
            return string;
        }

        function format(flag, date) {
            if (flag === 'fr') {
                return [
                    pad(date.getDate()),
                    pad(date.getMonth() + 1),
                    date.getFullYear()
                ].join('/')
            }

            if (flag === 'it') {
                return [
                    date.getFullYear(),
                    pad(date.getMonth() + 1),
                    pad(date.getDate())
                ].join('-')
            }

            return 0;
        }

        $result = this.each(function () {
            let myDateAgpm = $(this);

            myDateAgpm.on('keyup', function (e) {
                if (e.key === 'Backspace' || e.key === 'Delete') {
                    $(this).val('');
                }
            });

            myDateAgpm.on('input', function () {
                let $this = $(this);
                let min = new Date($this.attr('min'));
                let max = new Date($this.attr('max'));
                let current = new Date(frToIt($this.val()));
                let required = $this.is(':required');

                this.setCustomValidity('');

                if (!required && !$this.val()) {
                    return 0;
                }

                if (required && !$this.val()) {
                    this.setCustomValidity('La date est obligatoire');
                    return 0;
                }

                //NAN
                if (isNaN(current.valueOf())) {
                    this.setCustomValidity('La date n\'est pas valide');
                    return 0;
                }

                //MIN
                if (!isNaN(min.valueOf()) && current < min) {
                    this.setCustomValidity('La date doit être supérieure ou égale au ' + format('fr', min));
                    return 0;
                }

                //MAX
                if (!isNaN(max.valueOf()) && current > max) {
                    this.setCustomValidity('La date doit être inférieure ou égale au ' + format('fr', max));
                    return 0;
                }

                return 0;
            });

            myDateAgpm.on('input', function () {
                let $this = $(this);
                let min = new Date($this.attr('min'));
                let max = new Date($this.attr('max'));
                let current = new Date(frToIt($this.val()));
                let required = $this.is(':required');

                this.setCustomValidity('');

                if (!required && !$this.val()) {
                    return 0;
                }

                if (required && !$this.val()) {
                    this.setCustomValidity('La date est obligatoire');
                    return 0;
                }

                //NAN
                if (isNaN(current.valueOf())) {
                    this.setCustomValidity('La date n\'est pas valide');
                    return 0;
                }

                //MIN
                if (!isNaN(min.valueOf()) && current < min) {
                    this.setCustomValidity('La date doit être supérieure ou égale au ' + format('fr', min));
                    return 0;
                }

                //MAX
                if (!isNaN(max.valueOf()) && current > max) {
                    this.setCustomValidity('La date doit être inférieure ou égale au ' + format('fr', max));
                    return 0;
                }

                return 0;
            });

            myDateAgpm.on('beforeSubmit', function () {
                let $this = $(this);
                if (isFr($this.val())) {
                    let current = new Date(frToIt($this.val()));

                    try {
                        $this.unmask();
                    } catch (error) {
                        //console.error(error);
                    }

                    $this.val(format('it', current))
                }
            });

            myDateAgpm
                .val(itToFr($(this).val()))
                .mask("00/00/0000")
                .trigger('input');

            return myDateAgpm;
        });

        $('form').on('submit', function () {
            $(this).find(':input').trigger('beforeSubmit');
        });

        return $result;
    };

}(jQuery));
